var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWrapping(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "15.000000pt",
    height: "15.000000pt",
    viewBox: "0 0 50.000000 50.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,50.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20 450 c0 -6 83 -10 230 -10 147 0 230 4 230 10 0 6 -83 10 -230 10 -147 0 -230 -4 -230 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 350 c0 -6 55 -10 145 -10 90 0 145 4 145 10 0 6 -55 10 -145 10 -90 0 -145 -4 -145 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410 305 l-54 -55 54 -55 c30 -30 58 -55 62 -55 4 0 8 50 8 110 0 61 -4 110 -8 110 -4 0 -32 -25 -62 -55z m50 -57 l0 -73 -37 37 -37 38 34 35 c19 19 35 35 37 35 2 0 3 -33 3 -72z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 250 c0 -6 55 -10 145 -10 90 0 145 4 145 10 0 6 -55 10 -145 10 -90 0 -145 -4 -145 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 150 c0 -6 55 -10 145 -10 90 0 145 4 145 10 0 6 -55 10 -145 10 -90 0 -145 -4 -145 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 50 c0 -6 83 -10 230 -10 147 0 230 4 230 10 0 6 -83 10 -230 10 -147 0 -230 -4 -230 -10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrapping);
export default __webpack_public_path__ + "static/media/wrapping.4fb217e952c5d9fee7f98a708a9f1810.svg";
export { ForwardRef as ReactComponent };